export const homePageHeight = '100vh'
export const aboutPageHeight = '100vh'
export const projectsPageHeight = '175vh'
export const techPageHeight = '175vh'
export const contactPageHeight = '100vh'
